<script setup lang="ts">

</script>

<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.46795 12.8333C3.85897 12.8333 3.5 12.4872 3.5 11.8904V5.15863C3.5 4.56781 3.85897 4.22168 4.46795 4.22168H8.87821C9.41026 4.22168 9.75641 4.4962 9.75641 4.96169C9.75641 5.42719 9.40385 5.70768 8.87821 5.70768H5.4359V7.45627H7.23077C9.16026 7.45627 10.5 8.52452 10.5 10.1179C10.5 11.7472 9.19231 12.8333 7.29487 12.8333H4.46795ZM5.4359 11.3951H6.8141C7.89103 11.3951 8.51923 10.9475 8.51923 10.1179C8.51923 9.28244 7.89103 8.82888 6.80769 8.82888H5.4359V11.3951Z" fill="currentColor"/>
    <path d="M3.57692 1.93055C3.57692 1.50867 3.94428 1.16666 4.39744 1.16666H9.02214C9.4753 1.16666 9.84266 1.50867 9.84266 1.93055C9.84266 2.35244 9.4753 2.69444 9.02214 2.69444H4.39744C3.94428 2.69444 3.57692 2.35244 3.57692 1.93055Z" fill="currentColor"/>
  </svg>
</template>

<style scoped>

</style>